/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
import { sourceNames, sourceTypes } from "./Sources";
import { GenealogySource } from "./types";

export const getSources = async () => {
  const response = await fetch("https://node.ladagevandoorn.nl/stamboom/bronnen/bekkers");
  const data = await response.json();
  return parseSources(data);
};

export const parseSources = (sources: { file: string }[]): GenealogySource[] => {
  const genSources: GenealogySource[] = [];
  let index = 1;
  sources.forEach((sourceFile) => {
    const year = parseInt(sourceFile.file.substring(0, 4));
    const source = sourceFile.file.substring(4, 6);
    const type = sourceFile.file.substring(6, 8);
    if (year && source && type) {
      const genSource = {
        index: index++,
        id: sourceFile.file.substring(0, sourceFile.file.indexOf(" ")),
        filename: sourceFile.file,
        name: sourceNames.get(source),
        year: year,
        type: sourceTypes.get(type),
        url: "https://ladagevandoorn.nl/assets/stamboom/bekkers/bronnen/" + sourceFile.file,
      } as GenealogySource;
      genSources.push(genSource);
    }
  });
  return genSources;
};
